import {
  RENEW_OR_REMOVE_AUTH_AGENT_BEGIN,
  RENEW_OR_REMOVE_AUTH_AGENT_SUCCESS,
  RENEW_OR_REMOVE_AUTH_AGENT_FAILURE
} from "./types";
import API from "../../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";

export const renewOrRemoveAuthAgent = type => async dispatch => {
  dispatch({ type: RENEW_OR_REMOVE_AUTH_AGENT_BEGIN });

  try {
    const response = await API({
      method: "POST",
      url: ENDPOINTS.UPDATE_AUTH_AGENT,
      data: {
        action: type
      }
    });

    if (response && response.status === "OK") {
      dispatch({ type: RENEW_OR_REMOVE_AUTH_AGENT_SUCCESS });
    } else {
      dispatch({ type: RENEW_OR_REMOVE_AUTH_AGENT_FAILURE });
    }
  } catch (error) {
    dispatch({
      type: RENEW_OR_REMOVE_AUTH_AGENT_FAILURE,
      payload: error.response.description
    });
  }
};
